// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddDisciplineModal_fieldSet__td8TX"};